<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let value;
    export let placeholder = '';
    export let required = false;
    export let cssClass = '';
    export let id = '';

    const dispatch = createEventDispatcher();

    const onChange = () => {
        value = value.replace(",", ".");
        dispatch('change', value);
    }
</script>

<input type="text" class="form-control { cssClass }" id="{ id }" bind:value="{ value }"
       oninput="this.value = this.value.replace(/[^0-9.,]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
       on:change="{ onChange }"
       autocomplete="off"
       {placeholder}
       {required}
/>
